import { BATCH_TRANSLATE_DOC, GLOSSARY_DROP_DOWN, RECENT_TRANSLATIONS, TRANSLATE_DOC, UPLOAD_FILE, VIEW_BATCH_TRANSLATE_DOC, VIEW_DOC, RECENT_VIEW, BATCH_TRANSLATE_DOC_MORE_THAN_20, GET_SIGNED_URL, HTML_FILE_TRANSLATE } from "./types";

export const uploadFile = (file, onSuccess, onError) => {
    return {
        type: UPLOAD_FILE,
        file,
        onSuccess,
        onError,
    };
};

export const translateDocAction = (data, onSuccess, onError) => {
    return {
        type: TRANSLATE_DOC,
        data,
        onSuccess,
        onError,
    };
};

export const translateBatchDocAction = (data, onSuccess, onError) => {
    return {
        type: BATCH_TRANSLATE_DOC,
        data,
        onSuccess,
        onError,
    };
};

export const viewTranslateBatchDocAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_BATCH_TRANSLATE_DOC,
        data,
        onSuccess,
        onError,
    };
};

export const viewDocAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_DOC,
        data,
        onSuccess,
        onError,
    };
};

export const glossaryDropDownAction = (data, onSuccess, onError) => {
    return {
        type: GLOSSARY_DROP_DOWN,
        data,
        onSuccess,
        onError,
    };
};

export const recentTranslationsAction = (data, onSuccess, onError) => {
    return {
        type: RECENT_TRANSLATIONS,
        data,
        onSuccess,
        onError,
    };
};


export const recentViewAction = (id, onSuccess, onError) => {
    return {
        type: RECENT_VIEW,
        id,
        onSuccess,
        onError,
    };
};

export const translateBatchDocMoreThan20Action = (data, onSuccess, onError) => {
    return {
        type: BATCH_TRANSLATE_DOC_MORE_THAN_20,
        data,
        onSuccess,
        onError,
    };
};



export const getSignedUrl = (data, onSuccess, onError) => {
    return {
        type: GET_SIGNED_URL,
        data,
        onSuccess,
        onError,
    };
};

export const htmlFileTranslateAction = (data, onSuccess, onError) => {
    return {
        type: HTML_FILE_TRANSLATE,
        data,
        onSuccess,
        onError,
    };
};
